/** 来源地址 */
export var Keyboard;
(function (Keyboard) {
    /** 退格 */
    Keyboard["BACK_SPACE"] = "Backspace";
    /** 键盘方向左 */
    Keyboard["ARROW_LEFT"] = "ArrowLeft";
    /** 键盘方向右 */
    Keyboard["ARROW_RIGHT"] = "ArrowRight";
})(Keyboard || (Keyboard = {}));
